import {useOverlays} from '~/services/overlay'

export default function Overlays() {
    const [overlays] = useOverlays()

    return (
        <>
            {overlays.map(([id, Component]) => <Component key={id}/>)}
        </>
    )
}
